var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"snackbar"}},[_c('h2',{staticStyle:{"color":"white"}},[_vm._v("Message sent successfully")])])
}]

export { render, staticRenderFns }